<template>
  <a-modal
    :title="isAdd ? '新建原始班级' : '修改原始班级'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 年级类型 -->
      <a-form-item
        label="年级类型"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          placeholder="请选择"
          v-decorator="[
            'classType',
            { rules: [{ required: true, message: '请选择' }] },
          ]"
          @change="change"
        >
          <a-select-option
            v-for="(item, value, index) in typeList"
            :key="index"
            :value="value"
            >{{ value }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <!-- 年级 -->
      <a-form-item
        label="年级"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          placeholder="请选择"
          v-decorator="[
            'grade',
            { rules: [{ required: true, message: '请选择' }] },
          ]"
        >
          <a-select-option
            v-for="(item, index) in classList"
            :key="index"
            :value="item.gradeTagName"
            >{{ item.gradeTagName }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <!-- 原始班级名称 -->
      <a-form-item
        label="班级名称"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'className',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
        />
      </a-form-item>

      <!-- 班主任 -->
      <a-form-item
        label="班主任"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'headteacherName',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          @blur="onblurTeacherName"
        />
      </a-form-item>

      <!-- 班主任电话 -->
      <a-form-item
        label="班主任电话"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          :maxLength="11"
          v-decorator="[
            'headteacherMobile',
            {
              rules: [
                {
                  required: true,
                  message: '请输入',
                },
              ],
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import sourceClass from '../../api/sourceClass'

import school from '../../api/school'

import classSet from '../../api/classSet'

import moment from 'moment'

export default {
  name: 'sourceClassFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      originalClassId: '',
      updateData: {},
      searchLoading_class: false, //搜索班级loading
      typeList: [], // 学校类型列表
      classList: [], // 年级列表
      formData: '',
      first: [],
      gradeId: '', // 如果教育局端修改当前学校的年级类型删掉了当前选择的年级类型 直接点确定报错 所以取这个字段
    }
  },
  methods: {
    //初始化，显示
    async init(type, params) {
      this.visible = true
      this.isAdd = type === 'add' ? true : false
      this.classList = []
      await this.getGrandListAndType()
      //初始化form表单数据
      if (params) {
        this.updateData = params
        let formData = {}
        formData.className = params.className
        formData.grade = params.grade
        formData.headteacherName = params.headteacherName
        formData.headteacherMobile = params.headteacherMobile
        //记录当前原始班级的ID
        formData.classType = params.tagName
        this.originalClassId = params.id
        this.classList = this.typeList[params.tagName] || []
        this.gradeId = params.gradeId
        setTimeout(() => {
          this.form.setFieldsValue(formData)
        }, 100)
      } else {
        this.form.resetFields()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },
    // 获取年级类型列表
    getGrandListAndType() {
      return new Promise((resolve) => {
        sourceClass
          .getGrandListAndType(this.$ls.get('schoolId'))
          .then((res) => {
            console.log(res)
            this.typeList = res.data
            resolve()
          })
      })
    },
    // 切换年级列表
    change(e) {
      this.classList = this.typeList[e]
      let formData = this.form.getFieldsValue()
      if (formData.grade) formData.grade = ''
      this.form.setFieldsValue(formData)
    },
    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        if (value.birthday) {
          value.birthday = value.birthday.format('YYYY-MM-DD')
        }
        if (value.grade) {
          let gradeRes = this.classList.find(
            (i) => i.gradeTagName == value.grade
          )
          value.gradeId = gradeRes ? gradeRes.gradeTagId : this.gradeId
        }
        if (value.classType) {
          value.tagName = value.classType
        }
        console.log('输入的内容是：', value)
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addOriginalClass(value)
          } else {
            this.updateOriginalClass(value)
          }
        }
      })
    },

    //新增原始班级
    addOriginalClass(value) {
      sourceClass.addOriginalClass(value).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addOriginalClass', res.data)
      })
    },

    //修改原始班级
    updateOriginalClass(value) {
      sourceClass
        .updateOriginalClass(this.originalClassId, value)
        .then((res) => {
          this.$message.success('修改成功')
          Object.assign(this.updateData, value)
          this.handleCancel()
          this.$emit('updateOriginalClass', res.data)
        })
    },

    // 检查含有中文的姓名中有空格，则自动去空格
    onblurTeacherName() {
      this.$nextTick(() => {
        let formData = this.form.getFieldsValue()
        const nickname = formData.headteacherName
        const res = /^[0-9a-zA-Z ]+$/.test(nickname)
        if (nickname && !res) {
          const len = nickname.length
          formData.headteacherName = nickname.replaceAll(' ', '')
          this.form.setFieldsValue(formData)
          if (len != nickname.length)
            this.$message.warning('姓名中不能包含空格，已经自动去空格')
        } else {
          formData.headteacherName = nickname ? nickname.trim() : null
          this.form.setFieldsValue(formData)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
</style>
